import { Icon, IconsEnum } from 'components/Icons';
import { useEffect } from 'react';
import styles from './PasswordCheckList.module.scss';

export type PasswordCheckListProps = {
  rules: Array<{
    label: string;
    pattern: RegExp | ((value: string) => boolean);
  }>;
  value: string;
  onCheckState?: (isValid: boolean) => void;
};

export function PasswordCheckList({ rules, value, onCheckState }: PasswordCheckListProps) {
  const isFunction = (pattern: RegExp | ((value: string) => boolean)): pattern is (value: string) => boolean => {
    return typeof pattern === 'function';
  };

  useEffect(() => {
    if (value) {
      const isPasswordValid = rules.every((rule) =>
        isFunction(rule.pattern) ? rule.pattern(value) : rule.pattern.test(value)
      );
      onCheckState && onCheckState(isPasswordValid);
    }
  }, [value]);

  return (
    <div className={styles.checkListContainer}>
      {rules.map(({ label, pattern }, index) => {
        const isValid = isFunction(pattern) ? pattern(value) : pattern.test(value);
        return (
          <span className={styles.label} key={`rule_${label}_${index}`}>
            {isValid && <Icon className={styles.successIcon} iconId={IconsEnum.SUCCESS} />}
            {label}
          </span>
        );
      })}
    </div>
  );
}
